import type { JSX } from 'react';

import { Waypoint } from 'react-waypoint';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useTrackSharePetitionOnlineView } from 'src/app/pages/starterDashboardV2/shared/hooks';
import type { WaypointCallbackArgs } from 'src/app/shared/components/layout/lazy';

import { ShareSocial } from './components/ShareSocial/index_new';
import { ShareUrl } from './components/ShareUrl/index_new';

export function ShareYourPetition(): JSX.Element {
	const { actions } = useTrackSharePetitionOnlineView();
	return (
		<section data-testid="share_module" className="bg-background-base px-4 py-8 md:p-12">
			<Waypoint
				onPositionChange={(waypointCallbackArgs: WaypointCallbackArgs) => {
					actions.trackView(waypointCallbackArgs);
				}}
			/>
			<div className="flex flex-col gap-6">
				<Text
					className="text-typography-strong text-size-heading-xs leading-8 md:text-size-heading-small"
					as="h3"
					fontWeight="bold"
				>
					<Translate value="corgi.petition.starter_dashboard.grow_petition.share_petition.title" />
				</Text>
				<div className="flex flex-col gap-6 lg:gap-2.5">
					<ShareSocial className="lg:grid-flow-none grid grid-cols-[repeat(auto-fill,_80px)] justify-between gap-y-6 lg:flex lg:grid-cols-none lg:gap-x-2.5 lg:gap-y-0 lg:overflow-x-auto" />
					<ShareUrl />
				</div>
			</div>
		</section>
	);
}
